<template>
  <el-form label-width="100px" class="app">
    <el-form-item label="薪资项目：">
      <el-input v-model="name" style="width: 90%" placeholder="病假工资" disabled="true"/>
    </el-form-item>
    <el-form-item label="备注：">
      <el-input v-model="remark" style="width: 90%" :autosize="{ minRows: 3, maxRows: 6 }" type="textarea"/>
    </el-form-item>
      <h4 style="margin-left: 20px">发放规则：</h4>
      <el-row class="bordered-container">
        <el-form-item label="月薪基数：" style="margin: 10px 0px 10px 40px " required>
          <el-input-number v-model="monthlyBase" :precision="2" style="width: 200px" min="0"
                           controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="折算系数：" style="margin: 10px 10px 10px 80px" required>
          <el-input-number v-model="conversionCoefficient" :precision="2" style="width: 200px" min="0" max="1" :step="0.01"
                           controls-position="right"></el-input-number>
        </el-form-item>
      </el-row>
    <el-form-item label="">
      <span style="color: red;margin-right: 5px">* </span>除产假、年假、哺乳假外，其它假期都按照此基数发放
    </el-form-item>
    <div style="margin-top: 15%;text-align: center ">
      <el-button type="primary" @click="saveButton">保存</el-button>
    </div>
  </el-form>

</template>
<script>
export default {
  name: "SickPay",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      radiusGroup: [],
      monthlyBase: '',
      conversionCoefficient: '',
      remark: ''
    }
  },

  methods: {
    async saveButton() {
      if (this.monthlyBase === null || this.monthlyBase.length === 0) {
        this.$message({
          message: "请填写月薪基数",
          type: "error"
        })
        return;
      }
      if (this.conversionCoefficient ===null||this.conversionCoefficient.length===0){
        this.$message({
          message:"请填写折算系数",
          type:"error"
        })
        return;
      }
      let pageId = {
        id: this.parentData.id
      }
      let params = {
        monthlyBase: this.monthlyBase,
        conversionCoefficient: this.conversionCoefficient,
        remark: this.remark,
        itemId: pageId.id
      }
      await this.$http("salaryRuleConfigureService.saveSickPay", params);
      this.$message.success("保存成功！");
      this.$fn.closeWindow();
      this.$fn.search();
    },
    async getData() {
      let params = {
        id: this.parentData.id
      }
      if (params.id !== undefined) {
        let data = await this.$http("salaryRuleConfigureService.getSickPayById", params);
        this.monthlyBase = data.monthly_base
        this.conversionCoefficient = data.conversion_coefficient
        this.remark = data.remark
      }
    }
  },
  mounted() {
    this.getData();
  }
}
</script>
<style scoped lang="less">

.demo-radius .title {
  color: var(--el-text-color-regular);
  font-size: 18px;
  margin: 10px 0;
}

.bordered-container {
  border: 0.5px solid lightgrey;
  padding: 15px;
  width: 95%;
  margin: 10px;
}

.app {
  margin: 20px;
}
</style>